export default __webpack_public_path__ + "assets/images/f87398c10738beedd1d205f2607219ab.svg";